import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "filters" }

import i18n from '@/i18n';
import { useEvents, Event } from '@/services/events.composable';
import { Actions, ShiftCMSState } from '@/store';
import { parseCookie } from '@/util/cookie.util';
import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'AppLanguage',
  setup(__props) {

const store = useStore<ShiftCMSState>();
const events = useEvents();
const lang = computed<string>(() => store.state.language);
const dirtyState = computed<boolean>(() => store.state.dirtyState);

const setLanguage = async (l: string) => {
  if (dirtyState.value) {
    alert('Save your work before changing the language');
    return;
  }

  if (lang.value !== l) {
    await store.dispatch(Actions.SetLanguage, l);
    events.emit(Event.LanguageChanged, l);
    i18n.global.locale = l as 'en' | 'nl';
  }
};

onMounted(() => {
  const cookies = parseCookie(document.cookie);

  i18n.global.locale =
    (cookies.lang as 'en' | 'nl') || (lang.value as 'en' | 'nl');
});

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_menu, null, {
      activator: _withCtx(({ props }) => [
        _createVNode(_component_v_btn, _mergeProps({
          density: "compact",
          flat: "",
          color: "success"
        }, props), {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(lang.value === 'nl' ? 'NL' : 'EN'), 1)
          ]),
          _: 2
        }, 1040)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_v_list, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_list_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_list_item_title, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      block: "",
                      compact: "",
                      variant: "outlined",
                      outlined: "",
                      onClick: _cache[0] || (_cache[0] = () => setLanguage(lang.value === 'nl' ? 'en' : 'nl'))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(lang.value === 'nl' ? 'EN' : 'NL'), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})